module.exports = __webpack_public_path__ + "img/confirmorder1.13300c6.png";